<ng-template #content>
    <div id="modal">
        <div class="modal-header font-weight-bold">
            <h4 class="modal-title font-weight-bold">
                <i class="fas fa-mobile cursor-pointer mr-10px"></i>
                <span>Login Now</span>
            </h4>
            <i (click)="this.modalService.dismissAll()"
               class="fas fa-times-circle pull-right text-danger cross-icon cursor-pointer"></i>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="appointment-form">
                        <form [formGroup]='loginForm' novalidate>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label class="mt-2 mb-2" for="username">Username</label>
                                        <input aria-describedby="login-username" autofocus="" class="form-control"
                                               formControlName="username"
                                               id="username" placeholder="Username" tabindex="1"
                                               type="text"/>
                                        <small *ngIf="submitted && loginForm.get('username').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label class="mt-2 mb-2" for="password">Password</label>
                                        <input [type]="passwordTextType ? 'text' : 'password'"
                                               aria-describedby="login-password"
                                               class="form-control form-control-merge" formControlName="password"
                                               id="password" placeholder="············"
                                               tabindex="2">
                                        <small *ngIf="submitted && loginForm.get('password').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button (click)="login()" [disabled]="submitting"
                    class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn">
                <i *ngIf="submitting" class="fas fa-spinner fa-pulse mr-1"></i>Login
            </button>
        </div>
    </div>
</ng-template>
<div class="home-slider slider-item-mv home-slider-two-mv home-slider-two owl-theme owl-carousel">
    <div class="slider-item addbtn ">
        <img class="d-none d-lg-block" src="assets/img/slider/slider_v001.webp">
        <img class=" d-lg-none" src="assets/img/slider/slider_sm_v01.webp">
        <button class="btn custom-banner-btn " routerLink="/appointment">Book Now</button>
    </div>
    <div class="slider-item addbtn">
        <img class="d-none d-lg-block" src="assets/img/slider/slider_v02.webp">
        <img class=" d-lg-none" src="assets/img/slider/slider_sm_v02.webp">
        <button class="btn custom-banner-btn " routerLink="/appointment">Book Now</button>
    </div>
    <div class="slider-item addbtn">
        <img class="d-none d-lg-block" src="assets/img/slider/slider_v03.webp">
        <img class=" d-lg-none" src="assets/img/slider/slider_sm_v03.webp">
        <button class="btn custom-banner-btn " routerLink="/appointment">Book Now</button>
    </div>
    <div class="slider-item addbtn">
        <img class="d-none d-lg-block" src="assets/img/slider/slider_v04.webp">
        <img class=" d-lg-none" src="assets/img/slider/slider_sm_v04.webp">
        <button class="btn custom-banner-btn" routerLink="/appointment">Book Now</button>
    </div>
    <div class="slider-item addbtn">
        <img class="d-none d-lg-block" src="assets/img/slider/slider_v05.webp">
        <img class=" d-lg-none" src="assets/img/slider/slider_sm_v05.webp">
        <button class="btn custom-banner-btn" routerLink="/appointment">Book Now</button>
    </div>
    <div class="slider-item addbtn">
        <img class="d-none d-lg-block" src="assets/img/slider/slider_v06.webp">
        <img class=" d-lg-none" src="assets/img/slider/slider_sm_v06.webp">
        <button class="btn custom-banner-btn" routerLink="/appointment">Book Now</button>
    </div>
</div>


<section class="welcome-area pt-50 pb-50" id="self-assessment">
    <div class="container">
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="section-title-two">
                    <span>Know your Doshas</span>
                    <h2>Self Assessment</h2>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 d-none d-lg-block">
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <p style="color: #232323;">Your health status will be revealed by taking this brief exam, which will
                    also help you make better decisions.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/liver-health-assessment')"
                     class="service-item-home cursor-pointer">
                    <div class="box">
                        <img height="80px" src="assets/img/dr_axico_icons/liver-savior.webp" width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Liver Health Assessment</span></div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/women-health-assessment')"
                     class="service-item-home cursor-pointer">
                    <div class="box">
                        <img height="80px" src="assets/img/dr_axico_icons/women-care.webp" width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Women Health Assessment</span></div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/male-health-assessment')" class="service-item-home cursor-pointer">
                    <div class="box">
                        <img height="80px" src="assets/img/dr_axico_icons/male%20rejuvenator.webp" width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Male Health Assessment</span></div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/obesity-assessment')" class="service-item-home cursor-pointer">
                    <div class="box">
                        <img height="80px" src="assets/img/dr_axico_icons/OBESITY.webp" style="margin-right: 10px"
                             width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Obesity<br> Assessment</span><br>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/diabetes-assessment')" class="service-item-home cursor-pointer">
                    <div class="box">
                        <img height="80px" src="assets/img/dr_axico_icons/diabetes-manager.webp" width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span> Diabetes<br> Assessment</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/thyroid-assessment')" class="service-item-home cursor-pointer">
                    <div class="box">
                        <img height="80px" src="assets/img/dr_axico_icons/thyro-guard.webp" width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Thyroid<br> Assessment<br></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/acidity-assessment')" class="service-item-home cursor-pointer">
                    <div class="box">
                        <img height="80px" src="assets/img/dr_axico_icons/acidity-uprooter.webp" width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Acidity <br>Assessment</span><br>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/joints-assessment')" class="service-item-home cursor-pointer">
                    <div class="box">
                        <img class="mr-10px" height="80px" src="assets/img/dr_axico_icons/ortho-fortify.webp"
                             width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Joints<br> Assessment</span><br>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/general-health-assessment')"
                     class="service-item-home cursor-pointer">
                    <div class="box">
                        <img height="80px" src="assets/img/dr_axico_icons/general%20helath%20examine.webp"
                             width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>General Health Assessment</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/uterine-fibroid-assessment')"
                     class="service-item-home cursor-pointer">
                    <div class="box">
                        <img height="80px" src="assets/img/dr_axico_icons/FIBROID.webp" width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Uterine Fibroid Assessment</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/kidney-assessment')" class="service-item-home cursor-pointer">
                    <div class="box">
                        <img height="80px" src="assets/img/dr_axico_icons/natural-kidney-care.webp" width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Kidney<br> Assessment<br></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <div (click)="goTo('/self-assessment/prakriti')" class="service-item-home cursor-pointer">
                    <div class="box">
                        <img height="80px" src="assets/img/dr_axico_icons/PSHYCOSOMATIC ANALYSIS IN AYURVEDA.webp"
                             width="100px">
                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Prakriti<br> Assessment<br></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 d-sm-block d-lg-none d-md-none d-lg-block">
                <div class="doctor-btn">
                    <a class="" routerLink="/self-assessments">See All</a>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 d-none d-md-block d-lg-none"
                 style="margin-left: 175px;">
                <div class="doctor-btn">
                    <a class="" routerLink="/self-assessments">See All</a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="welcome-area pb-50">
    <div class="container">
        <div class="row m-0">
            <div class="col-lg-6 p-0">
                <div class="welcome-item text-center">
                    <img alt="about-us" class="image" src="assets/img/about-us.webp" style="width: 80%">
                </div>
            </div>
            <div class="col-lg-6 p-0">
                <div class="welcome-item welcome-right">
                    <div class="section-title-two" style="max-width: fit-content;">
                        <span>About Us</span>
                        <h1 class="font-weight-bold"><b>Welcome to Dr. Axico. We have...</b></h1>
                    </div>
                    <ul>
                        <li data-wow-delay=".3s">
                            <i class="icofont-doctor-alt"></i>
                            <div class="welcome-inner">
                                <h3>Certified Doctors</h3>
                                <p>We are having a team of Specialized and skilled Ayurvedic Doctors with experience of
                                    10 + years.</p>
                            </div>
                        </li>
                        <li data-wow-delay=".5s">
                            <i class="icofont-stretcher"></i>
                            <div class="welcome-inner">
                                <h3>Best Medicinal Kits</h3>
                                <p>Our specialized medicines kits are clinically proved, recommended by experienced
                                    doctors and trusted by our patients.</p>
                            </div>
                        </li>
                        <li data-wow-delay=".7s">
                            <i class="icofont-network"></i>
                            <div class="welcome-inner">
                                <h3>Modern Technologies</h3>
                                <p>Our medicines are manufactured in supervision with a highly-skilled research team and
                                    with the latest Phyto nanotechnology which enhances medicinal potential over any
                                    disease.</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="doctors-area pb-50">
    <div class="container">
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="section-title-two" style="max-width: 530px">
                    <span>Medicinal Kits</span>
                    <h2>Our Certified Medicinal Kits</h2>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="doctor-btn d-lg-block d-none" style="float: right">
                    <a routerLink="/medicinal-kits">See All</a>
                </div>
            </div>
        </div>

        <div *ngIf="medicinalKits && medicinalKits.length > 0" class="row ">
            <div
                *ngFor="let product of medicinalKits"
                [ngClass]="product.product_status==='SOLD_OUT'?'col-sm-6 col-lg-4 col-xs-12 my-3 sold-out-effect':'col-sm-6 col-lg-4 col-xs-12 my-3'"
                data-wow-delay=".3s">
                <div class="doctor-item">
                    <div class="doctor-top">
                        <div *ngIf="product?.product_status!='IN_STOCK'">
                            <div class="product-ribbon">
                                <div *ngIf="product.product_status==='NEW'" class="new-stock-ribbon ">
                                    <span>New</span>
                                </div>
                                <div *ngIf="product.product_status==='SOLD_OUT'" class="sold-out-ribbon ">
                                    <span>Sold Out</span>
                                </div>
                            </div>
                        </div>
                        <img
                            *ngIf="product['product_image'] && product['product_image'][0] && product['product_image'][0]['file'] && product['product_image'][0]['file']['url']"
                            alt="{{product?.name}}"
                            class="cursor-pointer"
                            routerLink="/medicinal-kits/{{product?.url}}"
                            src="{{product['product_image'][0]['file']['url']}}">
                        <img
                            *ngIf="!product['product_image'] || !product['product_image'][0] || !product['product_image'][0]['file'] || !product['product_image'][0]['file']['url']"
                            alt="{{product?.name}}" class="img-width img-height"
                            routerLink="/medicinal-kits/{{product?.url}}"
                            src="assets/img/products/dummy.jpg">
                    </div>
                    <div class="doctor-bottom text-left">
                        <h6 class="cursor-pointer product-name ml-10" routerLink="/medicinal-kits/{{product?.url}}">
                            {{product?.name}}
                        </h6>
                        <span *ngIf="product?.rating == 5">
                            <i class="fas fa-star text-warning ml-10"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <!-- <i class="fas fa-star-half-alt text-warning"></i>-->
                        </span>
                        <span *ngIf="product?.rating == 4.5">
                            <i class="fas fa-star text-warning ml-10"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star-half-alt text-warning"></i>
                        </span>
                        <span *ngIf="product?.rating == 4">
                            <i class="fas fa-star text-warning ml-10"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-secondary"></i>
                            <!-- <i class="fas fa-star-half-alt text-warning"></i>-->
                        </span>
                        <span *ngIf="product?.rating == 3.5">
                            <i class="fas fa-star text-warning ml-10"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star-half-alt text-warning"></i>
                            <i class="fas fa-star text-secondary"></i>
                        </span>
                        <span *ngIf="product?.rating == 3">
                            <i class="fas fa-star text-warning ml-10"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-secondary"></i>
                            <i class="fas fa-star text-secondary"></i>
                        </span>
                        <span class="ml-10 f_16 cursor-pointer" routerLink="/medicinal-kits/{{product?.url}}">
                            <span class="color-blue" style="font-size: 18px">
                                <small>&#8377;</small>{{product?.total_price | number : '1.2-2'}}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="doctor-btn d-lg-none d-sm-block">
                    <a routerLink="/medicinal-kits">See All</a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="doctors-area">
    <div class="container">
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="section-title-two" style="max-width: 530px">
                    <span>Products</span>
                    <h2>Our Certified Products</h2>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="doctor-btn d-lg-block d-none" style="margin-top: -20px;float: right">
                    <a routerLink="/products">See All</a>
                </div>
            </div>
        </div>
        <div *ngIf="products && products.length > 0" class="row">
            <div
                *ngFor="let product of products"
                [ngClass]="product.product_status==='SOLD_OUT'?'col-sm-6 col-lg-3 col-xs-12 my-2 sold-out-effect':'col-sm-6 col-lg-3 col-xs-12 my-2'"
                data-wow-delay=".3s">
                <div class="doctor-item">
                    <div class="doctor-top">
                        <div *ngIf="product?.product_status!='IN_STOCK'">
                            <div class="product-ribbon">
                                <div *ngIf="product.product_status==='NEW'" class="new-stock-ribbon ">
                                    <span>New</span>
                                </div>
                                <div *ngIf="product.product_status==='SOLD_OUT'" class="sold-out-ribbon ">
                                    <span>Sold Out</span>
                                </div>
                            </div>
                        </div>
                        <img
                            *ngIf="product['product_image'] && product['product_image'][0] && product['product_image'][0]['file'] && product['product_image'][0]['file']['url']"
                            alt="{{product?.name}}"
                            class="cursor-pointer"
                            routerLink="/products/{{product?.url}}"
                            src="{{product['product_image'][0]['file']['url']}}">
                        <img
                            *ngIf="!product['product_image'] || !product['product_image'][0] || !product['product_image'][0]['file'] || !product['product_image'][0]['file']['url']"
                            alt="{{product?.name}}" class="img-width img-height"
                            routerLink="/products/{{product?.url}}"
                            src="assets/img/products/dummy.jpg">
                    </div>
                    <div class="doctor-bottom text-left">
                        <h6 class="cursor-pointer product-name ml-10" routerLink="/products/{{product?.url}}">
                            {{product?.name}}
                        </h6>
                        <span *ngIf="product?.rating == 5">
                            <i class="fas fa-star text-warning ml-10"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <!-- <i class="fas fa-star-half-alt text-warning"></i>-->
                        </span>
                        <span *ngIf="product?.rating == 4.5">
                            <i class="fas fa-star text-warning ml-10"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star-half-alt text-warning"></i>
                        </span>
                        <span *ngIf="product?.rating == 4">
                            <i class="fas fa-star text-warning ml-10"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-secondary"></i>
                            <!-- <i class="fas fa-star-half-alt text-warning"></i>-->
                        </span>
                        <span *ngIf="product?.rating == 3.5">
                            <i class="fas fa-star text-warning ml-10"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star-half-alt text-warning"></i>
                            <i class="fas fa-star text-secondary"></i>
                        </span>
                        <span *ngIf="product?.rating == 3">
                            <i class="fas fa-star text-warning ml-10"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-warning"></i>
                            <i class="fas fa-star text-secondary"></i>
                            <i class="fas fa-star text-secondary"></i>
                            <!--<i class="fas fa-star-half-alt text-warning"></i>-->
                        </span>
                        <span class="ml-10 f_16 cursor-pointer" routerLink="/products/{{product.id}}">
                            <span class="color-blue" style="font-size: 18px">
                                <small>&#8377;</small>{{product?.total_price | number : '1.2-2'}}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="doctor-btn d-lg-none d-sm-block">
                <a routerLink="/products">See All</a>
            </div>
        </div>
    </div>
</section>
<section class="doctors-area mt-0 mt-sm-5">
    <!--    <div class="d-none d-lg-block" style="margin-top: -105px;"></div>-->
    <div class="container">
        <!--        <div class="row">-->
        <!--            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12  diseases-section">-->
        <!--                <div class="diseases-section-header mx-sm-3">-->
        <!--                    <span>About Diseases</span>-->
        <!--                    <h2>Diseases</h2>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">-->
        <!--                <div class=" d-lg-block d-none mt-5 doctor-btn-parent" style="float: right">-->

        <!--                    <div class="doctor-btn">-->
        <!--                        <a routerLink="/diseases">See All</a>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="section-title-two" style="max-width: 530px">
                    <span>About Diseases</span>
                    <h2>Diseases</h2>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="doctor-btn d-lg-block d-none" style="margin-top: -20px;float: right">
                    <a routerLink="/diseases">See All</a>
                </div>
            </div>
        </div>
        <div class="row m-0 ">
            <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12  justify-content-center">
                <div class=" speciality m-2 " style="height: 100%;">
                    <img class="Speciality" src="assets/img/home-one/doctor/disease.webp"/>
                </div>
            </div>
            <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                <div class="">
                    <div class="speciality-item">
                        <div class="row m-0">
                            <div class="col-sm-4 col-lg-4">
                                <div (click)="goTo('/diseases/kidney-infection')"
                                     class="service-item-home cursor-pointer">
                                    <div>
                                        <img height="70px" src="assets/img/diseases/kidney_infections.webp"
                                             width="90px">
                                        <div class="cursor-pointer mt-10 font-size-18 fw-500">
                                            <span>Kidney Infections</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- </div>-->
                            </div>
                            <div class="col-sm-4 col-lg-4">
                                <div (click)="goTo('/diseases/hepatitis-b')"
                                     class="service-item-home cursor-pointer">
                                    <div>
                                        <img height="80px" src="assets/img/diseases/hepatities_B.webp" width="100px">
                                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Hepatities B</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 col-lg-4">
                                <div (click)="goTo('/diseases/bronchitis')"
                                     class="service-item-home cursor-pointer">
                                    <div>
                                        <img height="80px" src="assets/img/diseases/Bronchitis.webp" width="100px">
                                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Bronchitis</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 col-lg-4">
                                <div (click)="goTo('/diseases/liver-disease')"
                                     class="service-item-home cursor-pointer">
                                    <div>
                                        <img height="70px" src="assets/img/diseases/liver_disease.webp" width="90px">
                                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Liver Disease</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 col-lg-4">
                                <div (click)="goTo('/diseases/migraine')"
                                     class="service-item-home cursor-pointer">
                                    <div>
                                        <img height="70px" src="assets/img/diseases/migraine.webp" width="90px">
                                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Migraine</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 col-lg-4">
                                <div (click)="goTo('/diseases/flu')" class="service-item-home cursor-pointer">
                                    <div>
                                        <img height="70px" src="assets/img/diseases/flu.webp" width="90px">
                                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Flu</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 col-lg-4">
                                <div (click)="goTo('/diseases/chest-pain')"
                                     class="service-item-home cursor-pointer">
                                    <div>
                                        <img height="70px" src="assets/img/diseases/chest_pain.webp" width="90px">
                                        <div class="cursor-pointer mt-10 font-size-18 fw-500"><span>Chest Pain</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 col-lg-4">
                                <div (click)="goTo('/diseases/food-poisoning')"
                                     class="service-item-home cursor-pointer">
                                    <div>
                                        <img height="70px" src="assets/img/diseases/food_poisoning.webp" width="90px">
                                        <div class="cursor-pointer mt-10 font-size-18 fw-500">
                                            <span>Food Poisining</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4 col-lg-4">
                                <div (click)="goTo('/diseases/heart-disease')"
                                     class="service-item-home cursor-pointer">
                                    <div>
                                        <img height="70px" src="assets/img/diseases/heart_dieseas.webp" width="90px">
                                        <div class="cursor-pointer mt-10 font-size-18 fw-500">
                                            <span>Heart Diseases</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 d-lg-none text-center">
                        <div class="doctor-btn">
                            <a routerLink="/diseases">See All</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="speciality-area pt-100">
    <div class="d-none d-lg-block" style="margin-top: -176px;"></div>
    <div class="container">
        <div class="row mb-md-3">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12  diseases-section">
                <div class="diseases-section-header mx-sm-2 ">
                    <span>Speciality</span>
                    <h2>Our Expertise</h2>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            </div>
        </div>
        <div class="row">
            <div class="col-lg-7 col-md-12 col-sm-12 speciality-item">
                <div class="row m-lg-5">
                    <div class="col-sm-6 col-lg-6">
                        <div class="speciality-inner">
                            <i class="icofont-check-circled"></i>
                            <h3>Best Treatment Strategies</h3>
                            <hr>
                            <p>Our expert team & experienced Ayurvedic Doctors together have made the treatment
                                of complex diseases very simple.</p>
                        </div>
                    </div>
                    <div class="col-sm-6 col-lg-6">
                        <div class="speciality-inner">
                            <i class="icofont-check-circled"></i>
                            <h3>Best Medical Kits</h3>
                            <hr>
                            <p>Our doctors will provide a special kit of Ayurvedic medicines affined to their
                                respective disease.</p>
                        </div>
                    </div>

                    <div class="col-sm-6 col-lg-6">
                        <div class="speciality-inner">
                            <i class="icofont-check-circled"></i>
                            <h3>Diet & Lifestyle Planners</h3>
                            <hr>
                            <p>Our experts assist in selecting righteous food & adopting constructive
                                habits.</p>
                        </div>
                    </div>

                    <div class="col-sm-6 col-lg-6">
                        <div class="speciality-inner">
                            <i class="icofont-check-circled"></i>
                            <h3>24 Hours Doctors Availability</h3>
                            <hr>
                            <p class="mb-25px">Our Doctors are available 24*7 to serve you.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-md-12 col-sm-12">
                <div class=" expertise-banner ">
                    <img class="expertise-banner-img" height="100%"
                         src="assets/img/home-one/doctor/expertise_v01.webp"/>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="doctors-area pt-100 background-color-grey">
    <div class="container pb-70">
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                <div class="section-title-two">
                    <span>Doctors</span>
                    <h2>Meet Our Doctors</h2>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="doctor-btn d-lg-block d-none" style="margin-top: -20px;float: right">
                    <a routerLink="/doctor">See All</a>
                </div>
            </div>
        </div>
        <div class="row">
            <owl-carousel [options]="owlCarouselOptions">
                <ng-container *ngFor="let doctor of doctors">
                    <div class="item">
                        <div class="card" style="border-radius: 10px;">
                            <div class="doctor-item">
                                <div class="doctor-top">
                                    <img [src]="doctor.imageUrl" alt="Doctor" class="img-fluid" height="329px">
                                    <a [routerLink]="doctor.profileLink">View Profile</a>
                                </div>
                                <div class="doctor-bottom">
                                    <h3><a [routerLink]="doctor.profileLink">{{ doctor.name }}</a></h3>
<!--                                    <h6>{{ doctor.qualifications }}</h6>-->
                                    <span>{{ doctor.specialization }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </owl-carousel>
        </div>
    </div>
</section>

<div class="counter-area counter-area-two" style="position: sticky;">
    <div class="container">
        <div class="row counter-bg">
            <div class="col-sm-6 col-lg-3">
                <div class="counter-item">
                    <i class="icofont-people"></i>
                    <h3><span class="counter">20K</span>+</h3>
                    <p>Booked Appointment</p>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="counter-item">
                    <i class="icofont-doctor-alt"></i>
                    <h3><span class="counter">19K</span>+</h3>
                    <p>Happy Patients</p>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="counter-item">
                    <i class="icofont-medicine"></i>
                    <h3><span class="counter">1M</span>+</h3>
                    <p>Products sold</p>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="counter-item">
                    <i class="icofont-badge"></i>
                    <h3><span class="counter">10</span></h3>
                    <p>Years Experience</p>
                </div>
            </div>
        </div>
    </div>
</div>
<section class="appointment-area pb-100" style="background-image: url('assets/img/banners/appointment.webp')">
    <div class="container-fluid p-0">
        <ng-template #content2 let-modal2>
            <div id="modal2">
                <div class="modal-header font-weight-bold">
                    <h4 class="modal-title font-weight-bold">
                        <i class="fa-lock fas cursor-pointer mr-2"></i>
                        <span class="ml-10">Appointment Details</span>
                    </h4>
                    <button (click)="modal2.close('Save click')" aria-label="Close" class="btn-close"
                            type="button"></button>
                </div>
                <div class="modal-body">
                    <div class="card">
                        <div class="card-header">
                            <p class="text-success text-center">
                                Hey {{this.appointment.name}}, Your appointment booking process is initiated
                                successfully, Your Appointment Id is {{this.appointment.appointment_id}}.
                            </p>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col" style="text-align: -webkit-center;">
                                    <img alt="" class="mx-auto" height="100px" src="assets/img/checkmark.gif"
                                         width="100px">
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col">
                                    <div class="form-group" style="text-align: center;">
                                        <button (click)="modal2.close('Save click')" class="btn btn-outline-dark"
                                                type="button">close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #content3 let-modal3>
            <div id="modal3">
                <div class="modal-header font-weight-bold">
                    <h4 class="modal-title font-weight-bold">
                        <span class="ml-10">Enter OTP sent to your Contact No.</span>
                    </h4>
                    <button (click)="modal3.close('Save click')" aria-label="Close" class="btn-close"
                            type="button"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <form [formGroup]="OtpForm">
                                <div class="row">
                                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <input class="form-control" formControlName="otp" placeholder="Enter OTP"
                                                   required type="number">
                                            <small *ngIf="submitted && OtpForm.get('otp').hasError('required')"
                                                   class="text-danger">
                                                Field is required.
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mt-3">
                                        <div class="text-center">
                                            <button (click)="submitOtp(content2)" [disabled]="!OtpForm.valid"
                                                    class="btn btn-outline-primary btn-sm"
                                                    type="submit"><b>
                                                Submit</b></button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">

                </div>
            </div>
        </ng-template>
        <div class="appointment-item">
            <div class="appointment-layer">
                <h2>Book your appointment</h2>
                <span>We will confirm your appointment within 2 hours</span>
                <div class="appointment-form">
                    <form [formGroup]="appointmentForm" novalidate>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <i class="icofont-business-man-alt-1"></i>
                                    <label>Name</label>
                                    <input class="form-control" formControlName="name" placeholder="Enter your name"
                                           type="text">
                                    <small *ngIf="submitted && appointmentForm.get('name').hasError('required')"
                                           class="text-danger">
                                        Field is required.
                                    </small>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <i class="icofont-ui-call"></i>
                                    <label>Phone</label>
                                    <input class="form-control" formControlName="contact"
                                           placeholder="Enter your number"
                                           type="number">
                                    <small *ngIf="submitted && appointmentForm.get('contact').hasError('required')"
                                           class="text-danger">
                                        Field is required.
                                    </small>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <i class="icofont-business-man"></i>
                                    <label>Age</label>
                                    <input class="form-control" formControlName="age" placeholder="Your Age"
                                           type="number">
                                    <small *ngIf="submitted && appointmentForm.get('age').hasError('required')"
                                           class="text-danger">
                                        Field is required.
                                    </small>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <i class="icofont-user-alt-1"></i>
                                    <label>Gender</label>
                                    <select class="form-control" formControlName="gender">
                                        <option value="">Select gender</option>
                                        <option value="MALE">Male</option>
                                        <option value="FEMALE">Female</option>
                                        <option value="OTHER">Transgender</option>
                                    </select>
                                    <small *ngIf="submitted && appointmentForm.get('gender').hasError('required')"
                                           class="text-danger">
                                        Field is required.
                                    </small>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <i class="icofont-hospital"></i>
                                    <label>Symptoms</label>
                                    <input class="form-control" formControlName="symptoms"
                                           placeholder="Enter your symptoms"
                                           type="text">
                                    <small *ngIf="submitted && appointmentForm.get('symptoms').hasError('required')"
                                           class="text-danger">
                                        Field is required.
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button (click)="submit(content3)" class="btn btn-outline-primary btn-lg" type="submit"><b>
                                Submit</b></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="blog-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="section-title-two">
                    <span>Blogs</span>
                    <h2>Our latest blogs</h2>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="doctor-btn d-lg-block d-none" style="margin-top: -20px;float: right">
                    <a routerLink="/blogs">See All</a>
                </div>
            </div>
        </div>

        <div class="row">
            <div *ngFor="let blog of blogList | slice:0:3" class="col-sm-6 col-lg-4" data-wow-delay=".3s"
                 style="position: relative;">
                <div class="blog-item shadow mb-5 bg-body rounded">
                    <div class="blog-top">
                        <!--                        <pre>{{blog|json}}</pre>-->
                        <a (click)="goTo('blogs/'+blog?.title)"
                           class="cursor-pointer">
                            <img *ngIf="blog?.blog_cover?.url;else imageNotFound" alt="Blog"
                                 src="{{blog?.blog_cover?.url}}"/>
                            <ng-template #imageNotFound>
                                <img alt="Blog" src="assets/img/blog/p.webp"/>
                            </ng-template>
                        </a>
                    </div>
                    <div class="blog-bottom" style="position: relative;">
                        <h1 class="blog-header" style="">
                            <a (click)="goTo('blogs/'+blog?.title)"
                               class="cursor-pointer">
                                {{blog?.heading |uppercase}}
                            </a>
                        </h1>
                        <p class="blog-description">{{blog?.short_description | slice:0:100}}...</p>
                        <ul>
                            <li>
                                <a (click)="goTo('blogs/'+blog?.title)"
                                   class="blog-custom-btn cursor-pointer">
                                    Read More..
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="doctor-btn d-lg-none d-sm-block">
                    <a routerLink="/blogs">See All</a>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="pb-5">
    <div class="container">
        <div class="row">
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 order-lg-1 order-2 col-xs-12">
                <section class="review-area pb-100" style="background: transparent;">
                    <h2 class="text-center mb-5"><strong>Testimonals</strong></h2>

                    <div class="container">
                        <div class="main">
                            <div class="slider-nav">
                                <div>
                                    <div class="review-img">
                                        <img alt="Feedback" src="assets/img/147142.png">
                                    </div>
                                    <div class="review-details">
                                        <h3>Manish</h3>
                                    </div>
                                </div>
                                <div>
                                    <div class="review-img">
                                        <img alt="Feedback" src="assets/img/testomonial-2.png">
                                    </div>
                                    <div class="review-details">
                                        <h3>Amit</h3>
                                    </div>
                                </div>
                                <div>
                                    <div class="review-img">
                                        <img alt="Feedback" src="assets/img/testimonial-6.jpeg">
                                    </div>
                                    <div class="review-details">
                                        <h3>Aryan</h3>
                                    </div>
                                </div>
                                <div>
                                    <div class="review-img">
                                        <img alt="Feedback" src="assets/img/testomonial-4.png">
                                    </div>
                                    <div class="review-details">
                                        <h3>Rajendra</h3>
                                    </div>
                                </div>
                                <div>
                                    <div class="review-img">
                                        <img alt="Feedback" src="assets/img/testomonial-5.png">
                                    </div>
                                    <div class="review-details">
                                        <h3>Akhil</h3>
                                    </div>
                                </div>
                            </div>

                            <div class="slider-for">
                                <div>
                                    <p>My left leg had a six-year history of persistent pain, which interfered with my
                                        daily activities and led to anxiety and melancholy. I'm happy I decided to visit
                                        with Dr. Axico before switching from Allopathy to Ayurveda. And in just one
                                        month, I was free of the pain and developed a good outlook on life. The
                                        personnel is properly trained sanitary and professional. The doctor is skilled
                                        and makes sure the patient returns happy after receiving the proper care.</p>
                                </div>

                                <div>
                                    <p>The Dr. Axico clinic is where I began my PCOD therapy, and they were very
                                        thorough in their explanations. The doctor was also very kind and understanding
                                        of all my inquiries. I get in touch with her frequently and all of my problems
                                        have greatly improved. I'd suggest Dr. Axico for any gynecological issues.</p>
                                </div>

                                <div>
                                    <p>Dr.Axico clinic run with the utmost professionalism. The medical professionals
                                        are thoughtful, kind, and patient. My views about ayurveda have changed forever
                                        after using their ayurvedic products.</p>
                                </div>

                                <div>
                                    <p>Excellent and thorough patient care is encouraged in the wonderful Dr.Axico
                                        facility. The medical staff is well competent to handle patients successfully,
                                        and the facilities are kept in good condition. I heartily endorse undergoing
                                        treatments with Dr. Axico.</p>
                                </div>
                                <div>
                                    <p>For my backache, I came here. I had a panchkarma treatment and got extremely nice
                                        results. About 90% of my back pain is gone, and I feel great. Thanks, Dr.
                                        Axico</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12  order-lg-2  order-1 col-xs-12">
                <a class="mobile-image" href="https://play.google.com/store/apps/details?id=com.ms.draxico"
                   target="_blank">
                    <img alt="instagram" id="image" src="assets/img/online_consultation.webp"
                         style="margin-top: 64px;">
                </a>
                <div class="download-section">
                    <div class="text-center">
                        <a href="https://play.google.com/store/apps/details?id=com.ms.draxico"
                           style="text-align: center;"
                           target="_blank"><img alt="playstore"
                                                src="https://i.ibb.co/ZTHhz0b/playstore.png"
                                                style="width: 156px; margin-top: 30px;"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
